import { reactEvents } from "../../../../bridge/reactEvents";
import { angularEvents } from "../../../../bridge/angularEvents";
// @ngInject
function colourChangeDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(articleId, colourName) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'colourChangeDialogController as vm',
            templateUrl: 'services/dialogs/colourChangeDialog/colourChangeDialog.tpl.html',
            size: 'lg'
        };

        modalDefaults.resolve = {
            articleId: function() {
                return articleId;
            },
            colourName: function() {
                return colourName;
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function colourChangeDialogController(articleId, colourName, Rms2ProductsApiService, $q, $uibModalInstance, ToasterService) {
    var vm = this;
    
    vm.closeModal = closeModal;
    vm.saveColourChange = saveColourChange;
    vm.ongoingRequest = false;
    vm.articleId = articleId;
    vm.articleColours = {};
    vm.uniqueColourNames = [];
    vm.selectedColour = "";
    vm.replacementColourName = "";
    vm.colourNameIsTheSame = colourNameIsTheSame;

    // var unsubSaveColourChangeEvent = reactEvents.saveColourChange.subscribe((colourChange) => {
    //     ProductsApiService.upsertMetaFields(colourChange).then(function(response) {
    //         console.log("ColourChange successfully saved", response);
    //     }, function(error) {
    //         ToasterService.showError(error.message);
    //     });
    // });

    Rms2ProductsApiService.getArticleColours(vm.articleId).then(function(response) {
        vm.articleColours = response;
        console.log("Rms2 getArticleColours response: ", vm.articleColours);

        prepareColourNames(vm.articleColours);

        // When we decide to migrate this dialog to react
        // angularEvents.articleColoursHasChanged.dispatch(vm.articleColours);
    }, function(error) {
        console.log(error);
    });

    function prepareColourNames(articleColours) {
        vm.uniqueColourNames = [];
        var colours = articleColours.colourNames;

        vm.uniqueColourNames = [];

        var count = 1; 
        _.forEach(colours, function(c) {
            vm.uniqueColourNames.push({ id: count, colourName: c });
            count++;
        });

        vm.selectedColour = vm.uniqueColourNames[0];

        if (colourName) {
            var foundValue = _.find(vm.uniqueColourNames, function (n) { return n.colourName === colourName });
            if (foundValue) {
                vm.selectedColour = foundValue;
            }
        }
    }

    function closeModal(confirmation) {
        var response = {};
        
        // When we decide to migrate this dialog to react
        // unsubSaveColourChangeEvent();

        $uibModalInstance.close(confirmation);
    }

    function saveColourChange() {
        vm.ongoingRequest = true;
        var request = {
            articleId: vm.articleId,
            oldValue: vm.selectedColour.colourName,
            newValue: vm.replacementColourName
        }; 

        Rms2ProductsApiService.createColourChange(request).then(function(response) {
            ToasterService.showSuccess();
            closeModal(true);
        }, function(error) {
            ToasterService.showError(error.message);
        })
        .then(function() {
            vm.ongoingRequest = false; 
        });
    }

    function colourNameIsTheSame() {
        return vm.replacementColourName.toLowerCase() === vm.selectedColour.colourName.toLowerCase();
    }
}

angular
    .module('services.dialogs.colourChangeDialog', [])
    .service('colourChangeDialogService', colourChangeDialogService)
    .controller('colourChangeDialogController', colourChangeDialogController);